<p-messages key="info"></p-messages>
<p-toast key="toast" position="top-left" [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<h6 class="prd-h6"> Dashboard </h6>
<div class="card" *ngIf='displayState.workingDiv'>
    <div class="card-body">
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner>
            </div>
        </div>
    </div>
</div>
<hr class="prd-hr" />
<div class="card bg-light" *ngIf='!displayState.workingDiv' style="margin-top: 5px;">
    <div class="card-body" style="margin-bottom: 3px;">
        <div class="row">
          <div class="col-md-6 offset-3">
            <span> <h5>Number of cases which are due to expire within the next six months:
              <button class="btn btn-link" (click)="printExpirationListReport()"
              title="Print Expiration List (by Case #)">
                {{totalExpiringCases}}
              </button>
            </h5></span>
          </div>
          <div class="col-md-1 offset-2">
            <button class="btn btn-success" style="margin-left: 10px;" (click)="refreshDashboard()" title="Get latest Dashboard counts">Refresh</button>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-6 offset-3">
            <span><h5>
              Number of complex cases needing Initial Case Management Meeting:
              <button class="btn btn-link" (click)="printInitComplexCaseReport()" title="Print Complex Case Initial Management Meeting report">
              {{totalComplexNeedInitMeeting}}
              </button>
            </h5>
            </span>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-6 offset-3">
            <span> <h5>Number of complex cases needing to be noticed:
              <button class="btn btn-link" [disabled]="true" (click)="printNeedNoticeComplexCaseReport()" title="Print Complex Case Notice Missing report">
                {{totalComplexNeedNotice}}
              </button>
              </h5>
            </span>
          </div>
        </div>
    </div>
</div>
<div *ngIf='showChartMode > 0' class="card bg-light" style="margin-top: 5px;">
  <div class="card-body" style="margin-bottom: 3px;">
    <div class="row">
      <div class="col-md-12 bold" style="text-align: center;"><h4>Statistics Charts</h4></div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-8 offset-1">
        <label for="cmbYear" class="col-form-label">Case Year</label>
        <span style="margin-left: 10px;">
                    <select id="cmbYear" class="col-sm-3" [(ngModel)]='myYear'>
                        <option></option>
                        <option *ngFor="let year of yearList">{{year}}</option>
                    </select>
                </span>
        <span style="margin-left: 10px;">
                    <button class="btn btn-success" title="Click to generate stats and draw charts for selected Roll Year" (click)="runCaseStatsReport()">Generate Case Statistics</button>
                </span>
      </div>
      <div class="col-md-3">
                <span style="margin-left: 10px;">
                    Chart Type
                    <select [(ngModel)]="chartType" (change)="onChangeType()">
                        <option>line</option>
                        <option>bar</option>
                        <option>pie</option>
                    </select>
                </span>
        <span style="margin-left: 10px;">
                    <button class="btn btn-info" title="Click to export case data to Excel" (click)="exportExcel()">Export</button>
                </span>
      </div>
    </div>
  </div>
</div>
<div *ngIf='( (displayState.chartDiv == true) && (showChartMode > 0) )'>
    <div class="row container">
        <div class="col-md-12">
            <p-chart #myChartOther [type]="chartType" [data]="dynoChartData" [options]="chartOptions" width="90vw" height="60vh" (onDataSelect)="selectData($event)"></p-chart>
        </div>
    </div>
    <hr />
    <div class="row container" *ngIf='displayState.valDiffDiv'>
      <div class="col-md-12">
        <p-chart #myChart [type]="chartType" [data]="valueDiffData" [options]="valChartOptions" width="90vw" height="60vh" (onDataSelect)="selectValData($event)">
        </p-chart>
      </div>
    </div>
    <div *ngIf='showChartMode > 1'>
      <hr />
      <div class="row container">
        <div class="col-md-12">
          <p-chart #myChartAssessor [type]="chartType" [data]="assessorData" [options]="assessorChartOptions" width="90vw" height="60vh" (onDataSelect)="selectAssessorData($event)"></p-chart>
        </div>
      </div>

    </div>
</div>

